import {mapActions} from "vuex";

export default {
    data() {
        return {

        }
    },
    methods: {
        ...mapActions('modal', ['modalType_collabOpen', 'modalClose']),
    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/quality-service/component.js